import { defineMessages } from 'react-intl';

const messages = defineMessages({
  loneLinkedFulfillmentPlan: {
    defaultMessage:
      'This shipment is the only active shipment for a linked order and cannot be removed from it. Create another shipment for this order then try again.',
    id: 'Hnfx7N',
    description:
      'helper text for a disabled button - the shipment is the only shipment associated with a sales order, which prevents deletion',
  },
  loneLinkedSalesOrder: {
    defaultMessage: 'This is not a valid action. The shipment is only linked with this order. Contact support if the error occurs again.',
    id: 'ciwDrg',
    description: 'error message - the shipment is not associated with any other sales order',
  },
  hasLinkedInventory: {
    defaultMessage: 'The shipment contains items for this order. Remove the items from this shipment and try again.',
    id: '8sc1qa',
    description: 'error message - the shipment has inventory associated with the sales order',
  },
  statusPreventsUnlinking: {
    defaultMessage:
      "The shipment's status prevents removal. You can only remove a shipment that is On Hold, Awaiting Shipment, or Awaiting Payment.",
    id: 'sQs4OU',
    description: "helper text for a disabled button - the shipment's status prevents removal",
  },
  unknownUnlinkingError: {
    defaultMessage:
      'An unknown error occurred and the shipment was not removed from the order. Please try again later and contact support if the error occurs again.',
    id: '2hlHbl',
    description:
      'helper text for a disabled button - default error message indicating that the user\'s request to "unlink a shipment" failed',
  },
  unlinkModalHeader: {
    defaultMessage: 'Remove shipment',
    id: 'XBzCuN',
    description: 'unlink fulfillmentPlan modal - header',
  },
  unlinkModalBody: {
    defaultMessage:
      'The shipment will be removed from the current order (<b>Order: {orderNumber}</b>) and will remain a shipment in the original order (<b>Order: {survivingOrderNumbers}</b>).',
    id: 'MRdevh',
    description: 'unlink fulfillmentPlan modal - body',
  },
  unlinkButton: {
    defaultMessage: 'Remove shipment',
    id: 'hpWn4m',
    description: 'orderDetails.fulfillmentPlan.unlink',
  },
});

export default messages;
